export const isEarthDay = () => {
	const now = new Date()
	const year = now.getUTCFullYear()
	const month = now.getUTCMonth()
	const day = now.getUTCDate()

	const isEarthDayUTC = year === 2024 && month === 3 && day === 22

	const nowPST = new Date(now.valueOf() - 8 * 60 * 60 * 1000)
	const yearPST = nowPST.getUTCFullYear()
	const monthPST = nowPST.getUTCMonth()
	const dayPST = nowPST.getUTCDate()

	const isEarthDayPST = yearPST === 2024 && monthPST === 3 && dayPST === 22

	return isEarthDayUTC || isEarthDayPST
}
